// extracted by mini-css-extract-plugin
module.exports = {"container":"OneCategoryPage_container__1Rlaw","leafImage":"OneCategoryPage_leafImage__3XolO"};